import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { DynamicScriptLoaderServiceService } from '../../_services/dynamic-script-loader-service.service';
import { AuthenicationService } from '../../_services/authenication.service';
import { DoctorService } from '../../_services/doctor.service';
import {PatientsService } from "../../_services/patients.service";
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';

declare var $: any;
import * as moment from 'moment';

@Component({
  selector: 'app-singlepatientappointment',
  templateUrl: './singlepatientappointment.component.html',
  styleUrls: ['./singlepatientappointment.component.css']
})
export class SinglepatientappointmentComponent implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;

  id: string;
  clientid: string;
  returnUrl: string;
  appointments: any[] = [];
  total: any[] = [];
  today : any;

  // tslint:disable-next-line:max-line-length
  constructor(private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private doctorservice: DoctorService, private patientsservice: PatientsService ,private toaster: ToasterService) { }

  ngOnInit() {
    // DynamicScriptLoaderServiceService.adminScripts();
    // DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom.js');
    this.userdetaild = this.authenicationService.userDetails();

    this.id = this.userdetaild['_id'];
    this.clientid = this.route.snapshot.params.id;

    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    const payload = {
      docid: this.id,
      clientid: this.clientid
    };

    let now = moment();
    this.today = now.format('YYYY-MM-DD');

    // console.log(payload);
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getDoctorAppointment(payload);

  }

  getDoctorAppointment(docid) {
    this.doctorservice.getAppointmentOfSinglePatient(docid)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Appointments', data.ResponseMessage);
            let appoint = data.DoctorAppointment;
            for(let i = 0; i < appoint.length; i++){

              const list = {
                _id: appoint[i]['_id'],
                scheduleId: appoint[i]['scheduleId'],
                docid: appoint[i]['docid'],
                clientid: appoint[i]['clientid'],
                patientid: appoint[i]['clientid']['_id'],
                appointmentMode: appoint[i]['appointmentMode'],
                status: appoint[i]['status'],
                original_price: appoint[i]['original_price'],
                discount_price: appoint[i]['discount_price'],
                coupon_code: appoint[i]['coupon_code'],
                cancel_date: appoint[i]['cancel_date'],
                cancel_by: appoint[i]['cancel_by'],
                is_eligible_for_refund: appoint[i]['is_eligible_for_refund'],
                troubles: appoint[i]['troubles'],
                payment_status: appoint[i]['payment_status'],
                payment_details: appoint[i]['payment_details'],
                total_session: appoint.length,
              };
              this.appointments.push(list);
            }

            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('Appointments', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Doctor', error.error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  getPatientTotalAppointment(cid){
    const id = {
      clientid: cid
    };

    this.patientsservice.getPatientAppointment(id)
      .subscribe(
        (data: any) => {

          this.total.push(data.ClientAppointment.length);

        }
      );
    return this.total;
  }

  changeStatus(sid,status,date,time){

    let str;
    let eligible: Boolean;
    const dateFormat = "YYYY-MM-DD HH:mm:ss";
    let appdate = date+'T'+time+':00';
    let rightNow = moment().format(dateFormat);//now
    let appointmentDate = moment(appdate).format(dateFormat);

    // pass in hours as the second parameter to the diff function
    const differenceInHours = moment(appointmentDate).diff(rightNow, 'hours');
    str = 'Are you sure to Cancel Appointment';

    eligible = differenceInHours > 24;


    if(confirm(str)) {
      const payload = {
        appointmentId: sid,
        status: status,
        cancel_date: rightNow,
        cancel_by: 'doctor',
        is_eligible_for_refund: eligible
      };
      this.doctorservice.updateStatus(payload)
        .subscribe(
          (data: any) => {

            if (data && data.ResponseCode === '200') {
              //this.toaster.showSuccess('Appointments', data.ResponseMessage);
              const docpayload = {
                docid: this.id,
                clientid: this.clientid
              };
              this.getDoctorAppointment(docpayload);
              setTimeout( () => {
                $(function () {
                  $('#example').DataTable();
                });
              }, 1000);
            } else {
              this.toaster.showError('Appointments', data.ResponseMessage);
              setTimeout( () => {
                $(function () {
                  $('#example').DataTable();
                });
              }, 1000);
            }
            // this.router.navigate([this.returnUrl]);
          },
          error => {
            this.toaster.showError('Doctor', error.error.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          });
    }
  }

}
